import { EventCardType } from "@/components/EventCard/EventCard";
import { WPClient } from "@/wp/client/WPClient";

interface FetchPostsProps {
  locale: string | undefined;
  defaultLocale: string | undefined;
  startDate?: Date;
  endDate?: Date;
}

export const fetchEvents = async ({
  startDate,
  endDate,
  locale,
  defaultLocale,
}: FetchPostsProps) => {
  const client = new WPClient({ locale, defaultLocale });

  const data = await client.getEvents({
    fields: ["id", "link", "acf.header_events"],
    startDate,
    endDate,
  });

  const fetchedEvents =
    data?.posts?.map?.((post) => {
      const header = post?.acf?.header_events;
      return {
        id: post.id,
        start_date: header?.start_date || "",
        end_date: header?.end_date,
        location: header?.location,
        start_time: header?.start_time,
        end_time: header?.end_time,
        title: header?.title,
        excerpt: header?.excerpt,
        link: post.link,
      } as EventCardType;
    }) ?? [];

  return {
    posts: fetchedEvents,
    totalPosts: data.totalPosts,
    extraData: {
      itemsAfter: data.events_after,
      itemsBefore: data.events_before,
    },
  };
};
